"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _pager = _interopRequireDefault(require("../pager"));

var _empty = _interopRequireDefault(require("../empty"));

var _TableHeader = _interopRequireDefault(require("./TableHeader"));

var _TableBody = _interopRequireDefault(require("./TableBody"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var clsPrefix = 'kui-new-table';
var compatiblePrefix = 'kui-table--compatible';

var Table = function Table(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$dataSource = _ref.dataSource,
      dataSource = _ref$dataSource === void 0 ? [] : _ref$dataSource,
      _ref$headerStyle = _ref.headerStyle,
      headerStyle = _ref$headerStyle === void 0 ? {} : _ref$headerStyle,
      _ref$bodyStyle = _ref.bodyStyle,
      bodyStyle = _ref$bodyStyle === void 0 ? {} : _ref$bodyStyle,
      _ref$bordered = _ref.bordered,
      bordered = _ref$bordered === void 0 ? false : _ref$bordered,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$tableLayout = _ref.tableLayout,
      tableLayout = _ref$tableLayout === void 0 ? 'fixed' : _ref$tableLayout,
      pagination = _ref.pagination,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$onRowClick = _ref.onRowClick,
      onRowClick = _ref$onRowClick === void 0 ? function () {
    return null;
  } : _ref$onRowClick,
      _ref$showHeader = _ref.showHeader,
      showHeader = _ref$showHeader === void 0 ? true : _ref$showHeader,
      _ref$stripe = _ref.stripe,
      stripe = _ref$stripe === void 0 ? false : _ref$stripe;

  var _ref2 = _typeof(pagination) === 'object' && pagination,
      pageSize = _ref2.pageSize,
      curPage = _ref2.curPage;

  var _dataSource = _typeof(pagination) === 'object' && curPage && dataSource.length > pageSize ? dataSource.slice((curPage - 1) * pageSize, curPage * pageSize) : _toConsumableArray(dataSource);

  var cls = children ? (0, _classnames["default"])(className, compatiblePrefix) : (0, _classnames["default"])(clsPrefix, className, _defineProperty({}, "".concat(clsPrefix, "--bordered"), bordered), ["".concat(clsPrefix, "--tb-layout-").concat(tableLayout)]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", {
    className: cls,
    style: style || {}
  }, children || /*#__PURE__*/React.createElement(React.Fragment, null, showHeader ? /*#__PURE__*/React.createElement(_TableHeader["default"], {
    columns: columns,
    style: headerStyle
  }) : null, /*#__PURE__*/React.createElement(_TableBody["default"], {
    columns: columns,
    dataSource: _dataSource,
    style: bodyStyle,
    onRowClick: onRowClick,
    stripe: stripe
  }))), !dataSource.length && !children && /*#__PURE__*/React.createElement(_empty["default"], null), pagination && /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "__pagination"),
    style: pagination.position ? {
      textAlign: pagination.position
    } : {}
  }, /*#__PURE__*/React.createElement(_pager["default"], pagination)));
};

var _default = Table;
exports["default"] = _default;